import type { LangCode } from '@learnforge/i18n';
import { en } from './en';
import { nl } from './nl';
import { ro } from './ro';
import type { ArithKey } from './keys';

export const locales = {
  en,
  nl: nl as Record<ArithKey, string>,
  ro: ro as Record<ArithKey, string>,
} as const satisfies Partial<Record<LangCode, Record<ArithKey, string>>> & {
  en: Record<ArithKey, string>;
};
export type { ArithKey } from './keys';
